import {loadScript} from './load-script';

let cache: Promise<void> | null;

export type WindowWithStaffCard = {
    StaffCard?: StaffCard;
} & typeof window;

export interface StaffCard {
    new (element: HTMLElement, login: string): StaffCard;

    destruct(): void;
    onHover(): void;
}

async function initUserCard(): Promise<void> {
    const {StaffCard} = window as WindowWithStaffCard;

    if (StaffCard) {
        return;
    }

    if (cache instanceof Promise) {
        await cache;

        return;
    }

    cache = loadScript('https://yastatic.net/s3/staff-card/v2.2.0/staff-card.min.js');

    await cache;
}

function setIntranetUserCard(element: HTMLElement, options: {login: string}) {
    const {StaffCard} = window as WindowWithStaffCard;
    const {login} = options;

    if (StaffCard) {
        return new StaffCard(element, login);
    }

    throw new Error('useStaffCard: script not loaded');
}

export {setIntranetUserCard, initUserCard};
